import React from 'react';

import { impactMeta, stateMeta, typeMeta } from './lib/feedbackTypes';

/**
 * The three small labels every feedback row carries.
 *
 * Kept together because they are read together: status, kind, and how much
 * it hurts. Each one falls back to grey on an unrecognised value rather
 * than throwing, so a state the backend adds before the frontend knows
 * about it still renders.
 */

/** Where an item is. Uses the kit's pill so it matches the invoice screens. */
export function StatePill({ state }) {
  const meta = stateMeta(state);
  return (
    <span className={`iv-pill iv-pill--${meta.tone}${meta.live ? ' iv-pill--live' : ''}`}>
      <span className="iv-pill__dot" />
      {meta.label}
    </span>
  );
}

/** Bug, improvement or feature. */
export function TypeTag({ type }) {
  const meta = typeMeta(type);
  return <span className={`fb-tag fb-tag--${meta.tone}`}>{meta.label}</span>;
}

/**
 * How much it costs the person who raised it.
 *
 * "Nice to have" is deliberately silent: showing a grey tag on two thirds
 * of the board teaches people to stop reading the tags.
 */
export function ImpactTag({ impact, quiet = true }) {
  const meta = impactMeta(impact);
  if (quiet && impact === 'nice_to_have') return null;
  return <span className={`fb-tag fb-tag--${meta.tone}`}>{meta.label}</span>;
}
